import { type Argument, OPERAND_TYPE_FUNCTION } from '@atlaskit/jql-ast';
import type { IntlShape } from '@atlassian/jira-intl';
import type { SelectOption } from '@atlassian/jira-jql-builder-basic-picker/src/common/types.tsx';
import type { useHydratedValues$data } from '../../__generated__/useHydratedValues.graphql';
import { OperandValues } from '../../../../../../../common/constants.tsx';
import { getFunctionLabel } from '../../../../../../../utils/get-function-label/index.tsx';

export const getFunctionValue = (
	data: useHydratedValues$data,
	value: string,
	validOperandDisplayValues: undefined | Array<string>,
	intl: IntlShape,
	args: Argument[],
	fieldJqlTerm: string,
): SelectOption | undefined => {
	const invalid = Boolean(
		!validOperandDisplayValues ||
			!validOperandDisplayValues.includes(OperandValues[value]?.value || value),
	);

	if (value === 'membersOf') {
		const matchingField = (
			data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter
		)?.fields?.find(
			(field) => field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase(),
		);

		const fieldData = matchingField?.values?.find((v) => v?.jqlTerm && v.jqlTerm === args[0].value);

		if (fieldData?.values?.length) {
			const [hydratedFieldValue] = fieldData.values;
			if (hydratedFieldValue) {
				return {
					label: hydratedFieldValue.displayName,
					value: hydratedFieldValue.jqlTerm,
					itemType: OPERAND_TYPE_FUNCTION,
					optionType: 'avatar',
					isGroup: true,
					invalid,
				};
			}
		}

		return undefined;
	}

	const fieldValue = {
		label: getFunctionLabel(value, intl.formatMessage),
		value: OperandValues[value]?.value || value,
		itemType: OPERAND_TYPE_FUNCTION,
	};

	if (fieldValue.value === OperandValues.currentUser.value && !invalid) {
		return {
			...fieldValue,
			optionType: 'avatar',
			avatar: data?.user?.picture ?? '',
			invalid,
		};
	}

	return {
		...fieldValue,
		optionType: 'avatar',
		hideAvatar: true,
		invalid,
	};
};
